import { NzMessageService } from 'ng-zorro-antd';
import { ListenService } from './../../../../listen.service';
import { CacheService } from '@delon/cache';
import { generateFormData } from '@shared/utils/publicMethods';
import { HttpClient } from '@angular/common/http';
import { Component, OnInit, Output, EventEmitter, ElementRef } from '@angular/core';
import { loginUrls } from '@shared/urls/loginUrls';
import { Menu, MenuService } from '@delon/theme';
import { PublicParams } from '@shared/utils/publicParams';
import { UserDetailResp } from '@shared/utils/userDetailResp';

@Component({
    selector: 'header-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.less'],
})
export class HeaderNavComponent implements OnInit {
    oneMenuData: Array<any> = [];
    selectName: string;
    logoUrl: string;
    nzTabPosition = 'top';
    selectedIndex = 0;
    @Output() private _onSuccess = new EventEmitter();

    constructor(
        private http: HttpClient,
        private menuService: MenuService,
        private cacheService: CacheService,
        private msg: NzMessageService,
        private el: ElementRef,
    ) { }

    // 请求一级目录
    queryOneMenu() {
        const url = loginUrls.queryOneMenu;
        const params = '';
        this.http.post(url, params).subscribe((response: any) => {
            if (response.err_msg) {
                this.msg.error(response.err_msg);
            } else {
                this._onSuccess.emit('一级目录请求成功');
                this.oneMenuData = response;
                this.selectName = response[0].name;
                this.queryChildMenu(response[0]);
            }
        });
    }

    // 请求二级（三级）目录
    queryChildMenu(data: any) {
        this.selectName = data.name;
        const url = loginUrls.queryChilMenu;
        const params = generateFormData({ qxfdxid: data.openid });
        this.http.post(url, params).subscribe((response: any) => {
            const root: Menu[] = [
                {
                    text: '主导航',
                    group: false,
                    hideInBreadcrumb: false,
                    children: response,
                },
            ];
            this.menuService.add(root);
        });
    }

    isAdmin() {
        // 判断是否为超级管理员 是否请求一级目录
        this.cacheService.get(PublicParams.cacheUserName).subscribe((res: UserDetailResp) => {
            // 如果是管理员查询一级目录 二级目录
            if (res.role.includes('管理员')) {
                this.queryOneMenu();
                // 点击事件获取点击菜单，查左侧menu
                this.menuService.clear();
            }
        });
    }

    ngOnInit(): void {
        this.isAdmin();
    }
}
